module.exports = __webpack_public_path__ + "static/media/bandeau-01.be053f23.svg";